// The role reaches the DOM as a data attribute and site.css turns it into a glyph of the characters font,
// or into a masked image for the monster and the four Jaws of the Lion classes the font does not cover.
function BuildRoleIcon(participant: Participant): HTMLElement | null {
    if (participant.role === Role.DungeonMaster || participant.role === Role.Spectator) {
        return null;
    }

    const icon = document.createElement('span');
    icon.className = "role-icon";
    icon.dataset.role = participant.role;

    // The row itself is painted in the primary colour, so the icon takes the secondary - the same pair the
    // class dropdown uses. A monster has no class colours of its own and keeps the red site.css gives it.
    if (participant.role !== Role.Monster) {
        icon.style.color = participant.secondaryHexColor;
    }

    return icon;
}
